<template>
  <div>
    <div class='fixHeight' v-if="isShowMenu === 1"></div>
    <!-- <share-menu v-if="isShowMenu === 2"></share-menu> -->
    <Menu v-if="isShowMenu === 1"></Menu>
    <!-- 手机端 -->
    <router-view></router-view>
    <Foot v-if="isShowMenu === 1"></Foot>
  </div>
</template>
<script>
import Menu from '@/components/Mobile/Menu.vue';
import Foot from '@/components/Mobile/Footer.vue'
// import shareMenu from '@/components/Mobile/shareMenu.vue';
import { mapGetters } from 'vuex'
export default {
  components:{
    Menu,Foot
    // shareMenu
  },
  data(){
    return {
      index:0
    }
  },
  mounted(){
  },
  computed:{
    ...mapGetters(['isShowMenu'])
  },
}
</script>

<style lang="less" scoped>
.fixHeight{
  height: 90px
}
</style>
